import { api } from 'api';
import { FUNC_DEFAULT } from 'constants';
import { datePicker } from 'helpers';
import useAuth from 'hooks/useAuth';
import { isEmpty } from 'lodash';
import {
  PII_PROFILE_PERSONAL_DETAILS_DOB_NAME,
  PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_GENDER_NAME,
  PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
} from '../const';

const usePIIAPI = () => {
  const { token } = useAuth();

  const personalDetailsOfSignupPIIPayloadTransformFromInformation = (
    personalDetailsInformation
  ) => {
    if (isEmpty(personalDetailsInformation)) return {};
    return {
      firstName:
        personalDetailsInformation[PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME],
      otherNames:
        personalDetailsInformation[
          PII_PROFILE_PERSONAL_DETAILS_MIDDLENAME_NAME
        ],
      lastName:
        personalDetailsInformation[PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME],
      gender:
        personalDetailsInformation[PII_PROFILE_PERSONAL_DETAILS_GENDER_NAME],
      dob: datePicker.convertToLocalDateTimeWithTimeZone(
        personalDetailsInformation[PII_PROFILE_PERSONAL_DETAILS_DOB_NAME],
        datePicker.DATE_TIME_FORMAT_2
      ),
      job:
        personalDetailsInformation[PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]
          ?.key || '',
      previousJob:
        personalDetailsInformation[
          PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME
        ]?.key || '',
    };
  };
  const residentialAddressOfSignupPIIPayloadTransformFromInformation = (
    residentialAddressInformation
  ) => {
    if (isEmpty(residentialAddressInformation)) return {};
    return {
      fullAddress:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME
        ],
      unitNumber:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME
        ],
      streetNumber:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME
        ],
      streetName:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME
        ],
      streetType:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME
        ]?.key || '',
      postCode:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME
        ],
      suburbName:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME
        ],
      stateCode:
        residentialAddressInformation[
          PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME
        ],
    };
  };
  const signupPIIRequest = async ({
    personalDetailsInformation,
    residentialAddressInformation,
    callback = FUNC_DEFAULT,
    errorCallback = FUNC_DEFAULT,
  }) => {
    // signupPIIPayload = {
    //   consented: true,
    //   firstName: 'string',
    //   otherNames: 'string',
    //   lastName: 'string',
    //   gender: 'string',
    //   dob: '2026-02-28',
    //   job: 'string',
    //   previousJob: 'string',
    //   fullAddress: 'string',
    //   unitNumber: 'string',
    //   streetNumber: 'string',
    //   streetName: 'string',
    //   streetType: 'string',
    //   postCode: 'string',
    //   stateCode: 'string',
    //   suburbName: 'string',
    // };
    const signupPIIPayload = {
      consented: true,
      ...personalDetailsOfSignupPIIPayloadTransformFromInformation(
        personalDetailsInformation
      ),
      ...residentialAddressOfSignupPIIPayloadTransformFromInformation(
        residentialAddressInformation
      ),
    };
    console.log(
      `⭐ usePIIAPI 👉 signupPIIRequest ➡️ signupPIIPayload ↩`,
      signupPIIPayload
    );
    try {
      await api.signupPII(token, signupPIIPayload);
      callback?.();
    } catch (error) {
      console.error(
        `🔥 usePIIAPI ❌ signupPIIRequest ➡️ ERROR ↩`,
        error?.message
      );
      errorCallback?.(error?.response?.data);
    }
  };

  const processVerifyOTPCodeRequest = async ({
    otpCode,
    callback = FUNC_DEFAULT,
    errorCallback = FUNC_DEFAULT,
  }) => {
    try {
      const verifyOTPPayload = {
        token,
        otp: otpCode,
      };
      console.log(
        `⭐usePIIAPI 👉 processVerifyOTPCodeRequest ➡️ verifyOTPPayload ↩`,
        verifyOTPPayload
      );
      const { data } = await api.processVerifyOTPCode(token, verifyOTPPayload);
      if (!isEmpty(data)) {
        callback?.(data);
      }
    } catch (error) {
      console.error(
        `🔥 usePIIAPI ❌ processVerifyOTPCodeRequest ➡️ ERROR ↩`,
        error?.message
      );
      errorCallback?.(error?.response?.data);
    }
  };

  return {
    signupPIIRequest,
    processVerifyOTPCodeRequest,
  };
};

export default usePIIAPI;
